export default "__VITE_ASSET__SbTJ3Dto__"